import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HasId } from "../contract/common.contract";
import { IQueryFilter, QueryResult } from "../model/api/query-filter.model";
import { SupportingDocument } from "../model/document.model";
import { RefRegion } from "../model/ref/ref-region.model";
import { createUrl, queryToParams } from "../util/api.util";
import { GenericApi } from "./generic.api";

// Convenience Type
type T = SupportingDocument;

@Injectable({
  providedIn: "root",
})
export class DocumentApi extends GenericApi<T> {
  path = "document";

  public httpClient = inject(HttpClient);

  list = (query: IQueryFilter): Observable<QueryResult<T & HasId>> => {
    return this.httpClient.get<QueryResult<T & HasId>>(createUrl(this.path), {
      params: queryToParams(query),
    });
  };

  create = (model: Partial<T>): Observable<T & HasId> => {
    return this.httpClient.post<T & HasId>(createUrl(this.path), model);
  };
}
